export default "__VITE_ASSET__7J6xOZZu__"